import $ from "jquery"; // $ will be available globally on all files
import "./js/components/validation";
import "bootstrap";

import "./scss/main.scss";
import { bindToggle, removeTimeFromDate } from "./js/components/helpers";
import {
  getSelectedDocsOnSubmit,
  changeNoOfDocs,
  checkSelectedBoxesOnLoad,
} from "./js/components/doc-selection";
import { validateForm } from "./js/components/validation";
import { popoverSettings } from "./js/components/misce";
import {
  showSelectedFile,
  deleteSuuportingDocs,
  showUploadedFile,
} from "./js/components/file-upload";

$(function () {
  bindToggle(".js-toggle-trigger", ".js-toggle-target", ".js-toggle-block");
  validateForm();
  getSelectedDocsOnSubmit();
  changeNoOfDocs();
  $('[data-toggle="popover"]').popover({
    trigger: "focus click hover",
  });

  $('[data-toggle="tooltip"]').tooltip();
  popoverSettings();
  checkSelectedBoxesOnLoad();
  showSelectedFile();
  deleteSuuportingDocs();
  showUploadedFile();
  removeTimeFromDate();
});
